import { Button, Modal } from "react-bootstrap";
import {
  ModalButton,
  ModalTitle,
  ModalText,
} from './latestNewsubmitStyle'
import { MESSAGE } from '../../../utils/message';

const ErrorModal = ({errorMsg,setErrorFlag,errorFlag }: any) => {
  return (
    <Modal show={errorFlag} className='claim-nonprofit-modal'
      onHide={() => setErrorFlag(false)} centered>
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <ModalTitle>Error ....</ModalTitle>
        <ModalText> {errorMsg}</ModalText>
        <ModalButton>
          <Button className='blank-btn modal-btn' onClick={() => setErrorFlag(false)}>{MESSAGE.cancelBtn}</Button>
        </ModalButton>
      </Modal.Body>
    </Modal>
  )
}

export default ErrorModal;